<template>
    <div>
        Placeholder for Users
    </div>
</template>

<script>
export default {
  name: 'admin-home'
}
</script>
